import { render, staticRenderFns } from "./PaymentBankChannelsInstallmentTable.vue?vue&type=template&id=4b05dbde&scoped=true&"
import script from "./PaymentBankChannelsInstallmentTable.vue?vue&type=script&lang=js&"
export * from "./PaymentBankChannelsInstallmentTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBankChannelsInstallmentTable.vue?vue&type=style&index=0&id=4b05dbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05dbde",
  null
  
)

export default component.exports